import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from '@angular/fire/compat/firestore';
import { FirestoreError, Timestamp } from '@angular/fire/firestore';
import { catchError, map, Observable, take } from 'rxjs';
import { AppExceptionModel } from '../models/app-exception.model';
import { Exam } from '../models/exam.school.model';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class SchoolExamService {
  http = inject(HttpClient);
  afs: AngularFirestore = inject(AngularFirestore);
  utilsService = inject(UtilsService);

  constructor() {}

  getExams({
    groupId,
    limit,
    lastRecord,
  }: {
    groupId: string;
    limit?: number;
    lastRecord?: Timestamp;
  }): Observable<Exam[]> {
    let query: AngularFirestoreCollection<Exam> = this.afs
      .collection('groups')
      .doc(groupId)
      .collection('exams', (ref) => {
        var reference = ref.where('groupId', '==', groupId);

        reference = reference.orderBy('modified', 'desc');

        if (limit) reference = reference.limit(limit ?? 10);

        if (lastRecord) reference = reference.startAfter(lastRecord);

        return reference;
      });

    return query.get().pipe(
      take(1),
      map((changes) => {
        return changes.docs.map((a) => {
          var data: Exam = a.data() as Exam;
          data.id = a.id;
          return data;
        });
      }),
      catchError((error: FirestoreError) => {
        // console.log(`GradeExamService :: getGradeExamsByGroup: Error: ${error}`);
        return [];
      }),
    );
  }
  catch(error: any) {
    // console.log(
    //   `GradeExamService :: getGradeExamsByGroup: Error: ${error?.toString()}`
    // );
    const appException: AppExceptionModel = {
      code: 'ERR_GET_EXAMS',
      message: 'Unable to fetch Exams at this time. Please try again later',
      title: 'Error Fetching Exams',
    };
    throw appException;
  }

  getExamById(groupId: string, id: string): Observable<Exam> {
    const doc = this.afs
      .collection('groups')
      .doc(groupId)
      .collection('exams')
      .doc(id)
      .get();
    return doc.pipe(
      take(1),
      map((doc) => {
        return { ...doc.data(), id: id } as Exam;
      }),
    );
  }

  async create(groupId: string, exam: Exam): Promise<string> {
    // console.log('ExamService:: create:', JSON.stringify(exam, null, 2));
    const doc = await this.afs
      .collection('groups')
      .doc(groupId)
      .collection('exams')
      .add(exam);
    return doc.id;
  }

  async update(groupId: string, id: string, exam: Exam): Promise<void> {
    // console.log(
    //   `ExamService:: update: ${id}: `,
    //   JSON.stringify(exam, null, 2)
    // );
    return this.afs
      .collection('groups')
      .doc(groupId)
      .collection('exams')
      .doc(id)
      .update(exam);
  }

  async delete(groupId: string, id: string): Promise<void> {
    return this.afs
      .collection('groups')
      .doc(groupId)
      .collection<Exam>('exams')
      .doc(id)
      .delete();
  }
}
